
import React, { useState } from "react";
import "./ContactPage.css";
import { BsFillThreadsFill } from "react-icons/bs";
import { FaFacebookSquare, FaInstagramSquare, FaLinkedin } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";

export default function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        access_key: "63ce8990-b264-402a-a6bf-4719e90a52d0", 
        name: formData.name,
        email: formData.email,
        message: formData.message,
      }),
    });

    const result = await response.json();
    if (result.success) {
      setStatus("Message sent successfully!");
      setFormData({ name: "", email: "", message: "" });
    } else {
      setStatus("Failed to send message. Try again.");
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        {/* Left Side - Contact Form */}
        <div className="contact-form">
          <h2>SEND US A MESSAGE</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit">Send Message</button>
            {status && <p className="form-status">{status}</p>}
          </form>
        </div>

        {/* Right Side - Contact Info */}
        <div className="contact-info">
          <h2>CONTACT INFO</h2>
          <p className="info-text">
            Have questions about buying, selling, or investing? We’re here to
            help you find the perfect property.
          </p>

          <div className="info-item">
            <span className="icon">📞</span>
            <p>+234 (0) 808 531 2366</p>
          </div>

          <div className="info-item">
            <span className="icon">📍</span>
            <p>Suite 401b, Midel Centre, Oladipo Diya Way, Gudu, Abuja</p>
          </div>

          <div className="info-item">
            <span className="icon">✉️</span>
            <p>eaekanemconsulting.esv@gmail.com</p>
          </div>

          <h3>SOCIAL MEDIA</h3>
          <div className="social-icons">
            <a href="https://www.linkedin.com/in/eaekanemconsulting-estate-surveyors-and-valuers-6ba23b286/" aria-label="LinkedIn"><FaLinkedin /></a>
            <a href="https://www.instagram.com/eaekanem_consulting/" aria-label="Instagram"><FaInstagramSquare /></a>
            <a href="https://x.com/EA_Ekanem" aria-label="Twitter"><BsTwitterX /></a>
            <a href="https://www.threads.net/@eaekanem_consulting" aria-label="Threads"><BsFillThreadsFill /></a>
            <a href="https://web.facebook.com/profile.php?id=100095212459873" aria-label="Facebook"><FaFacebookSquare /></a>
          </div>
        </div>
      </div>

      {/* Google Map */}
      <div className="map-container">
        <iframe
          title="Google Map"
          src="https://www.google.com/maps?q=Suite%20401b%2C%20Midel%20Centre%2C%20Oladipo%20Diya%20Way%2C%20Gudu%2C%20Abuja&output=embed"
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
}
